const deviceUtils = {
  /* 微信浏览器 */
  isWeChatBrowser: function () {
    let ua = navigator.userAgent.toLowerCase()
    return /micromessenger/.test(ua)
  }
}

export default deviceUtils
